export default "__VITE_ASSET__DPyRRdcT__"